export default function trackEvent(event: string, info: any): void {
  console.log(
    `Track Event: %cEvent- ${event} %cInfo - ${info}`,
    "color:red;",
    "color:green;"
  );
}
